var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-header"},[_c('h4',[_vm._v("\n    "+_vm._s(_vm._T('My Orders'))+"\n    "),_c('router-link',{attrs:{"to":{ name: 'profile.history' }}},[_c('img',{staticClass:"d-sm-none",attrs:{"src":"/images/svg/global/backward-time.svg","alt":""}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }